import React from "react";
import styled from "styled-components";
import baseStyle from "../../style";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { useFieldValue } from "../../hooks";

const Date = styled(DatePicker)`
  ${baseStyle}
`;

export default (props) => {
  const [date, setDate] = React.useState();
  const [getFieldNameValue] = useFieldValue();

  function onChange(e) {
    setDate(e)
    if (props.onChange) {
      const data = getFieldNameValue({ type: "date", name: props.name }, e, null);
      props.onChange(data);
    }
  }
  function handleDateValue() {
    if (props.value) {
        setDate(props.value)
    }
  }
  React.useEffect(handleDateValue, [props.value]);
  return (
    <Date
      disabled={props.disabled}
      onChange={onChange}
      minDate={props.minDate}
      maxDate={props.maxDate}
      selected={moment(date)}
      locale="pt-bR"
    />
  );
};



// WEBPACK FOOTER //
// ./src/_components/Input/components/Date/index.jsx